import { COMPARISON_ITEM_TYPES } from '@/utils/constants';

export interface LegendItem {
  label: string;
  className: string;
}

const createLegendItem = (label: string, modifier: string): LegendItem => ({
  label,
  className: `scenario-graph-legend__item scenario-graph-legend__item--${modifier}`,
});

export function getLegendItemsFromSeries(options?: { showHistoricalProjection?: boolean }): LegendItem[] {
  const showProjection = !!options?.showHistoricalProjection;

  return [
    createLegendItem('Investments', 'default'),
    createLegendItem('Benchmark', 'benchmark'),
    ...(showProjection ? [createLegendItem('Historical Projection', 'projection')] : []),
  ];
}
